// extracted by mini-css-extract-plugin
export default {"root":"Eo-t8","large":"_3xlfW","hoverable":"_1G6V8","medium":"_2CpdK","small":"_2XDTG"};